export const DATE_FORMAT = 'YYYY/MM/DD';
export const DATE_FORMAT_EXPORT = 'YYYYMMDD';
export const DATE_HYPHEN_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY/MM/DD HH:mm';
export const DATE_PICKER_FORMAT = ['YYYY/MM/DD', 'YYYY/M/D'];
export const TIME_PICKER_FORMAT = 'HH:mm';

export const TOKEN_COOKIE = 'access-token';
export const REFRESH_TOKEN_COOKIE = 'refresh-token';
export const REQUEST_TIME_OUT = 60000;

export const PLACEHOLDER_SELECT = '選択';
export const PLACEHOLDER_INPUT = '入力';
export const COMMON_MESSAGE_ERROR =
  '問題が発生しました。もう一度お試しください。';
export const COMMON_MESSAGE_TIMEOUT =
  'リクエストタイムアウトが60秒を超えました。もう一度お試しください。';
export const COMMON_ERR_NETWORK = 'ERR_NETWORK';
export const COMMON_ERR_NO_PERMISSION = 'NO_PERMISSION';
export const COMMON_ERR_TIMEOUT = 'ERR_TIMEOUT';
export const COLOR_TOOLTIP = 'var(--color-text-primary)';
export const DATA_EMPTY = '-';
export const TEN = 10;
export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_PAGE_NUMBER = 1;
export const MAX_LENGTH_255 = 255;

export const OPTION_EMPTY = { label: '', value: '' };
export const COMPANY_DEFAULT_OPTION = {
  value: '',
  label: '全て',
  children: '',
};
// Standardized "all" filter option shared across search screens (value "" = no filter applied)
export const ZENBU_OPTION = { label: '全て', value: '' };
export const REGEX_REPLACE_TEMPERATURE = /(\.0)+$/; // convert value 1.0.0 to 1.0
export const REGEX_DECIMAL_TEMPERATURE = /^\d+(\.\d)?$/;
export const REGEX_CHARACTER_NUMBER = /^[a-zA-Z0-9 ]*$/;
export const REGEX_FORMAT_TEMPERATURE = /^(-?\d{1,3})\d*(\.\d)?/; // Convert value to format xxx.x or -xxx.x
export const REGEX_CHECK_FORMAT_TEMP = /^(-?\d{1,3})(\.\d)?$/; // Check value match format xxx.x or -xxx.x

// RegEx
export const NUMBER_REGEX = /^([0-9]{0,}[.])?[0-9]{0,}$/;
export const NUMBER_ONLY_REGEX = /^[0-9]{0,}$/;

export const ROW_GUTTER = {
  HORIZONTAL: 8,
  VERTICAL: 16,
};

// mockData
export const DISTRICT_LIST_DATA = [
  {
    id: '1',
    key: 1,
    companyDepartmentCode: '101_会社',
    districtCode: '01',
    districtName: 'SM第1地区',
  },
  {
    id: '2',
    key: 2,
    companyDepartmentCode: '102_会社',
    districtCode: '02',
    districtName: 'SM第2地区',
  },
  {
    id: '3',
    key: 3,
    companyDepartmentCode: '103_会社',
    districtCode: '03',
    districtName: 'SM第3地区',
  },
  {
    id: '4',
    key: 4,

    companyDepartmentCode: '104_会社',
    districtCode: '04',
    districtName: 'SM第4地区',
  },
  {
    id: '5',
    key: 5,

    companyDepartmentCode: '105_会社',
    districtCode: '05',
    districtName: 'SM第5地区',
  },
  {
    id: '6',
    key: 6,
    companyDepartmentCode: '106_会社',
    districtCode: '06',
    districtName: 'SM第6地区',
  },
  {
    id: '7',
    key: 7,
    companyDepartmentCode: '107_会社',
    districtCode: '07',
    districtName: 'SM第7地区',
  },
  {
    id: '8',
    key: 8,
    companyDepartmentCode: '108_会社',
    districtCode: '08',
    districtName: 'SM第8地区',
  },
  {
    id: '9',
    key: 9,
    companyDepartmentCode: '109_会社',
    districtCode: '09',
    districtName: 'SM第9地区',
  },
  {
    id: '10',
    key: 10,
    companyDepartmentCode: '110_会社',
    districtCode: '10',
    districtName: 'SM第10地区',
  },
  {
    id: '11',
    key: 11,
    companyDepartmentCode: '111_会社',
    districtCode: '11',
    districtName: 'SM第11地区',
  },
  {
    id: '12',
    key: 12,
    companyDepartmentCode: '112_会社',
    districtCode: '12',
    districtName: 'SM第12地区',
  },
  {
    id: '13',
    key: 13,
    companyDepartmentCode: '113_会社',
    districtCode: '13',
    districtName: 'SM第13地区',
  },
  {
    id: '14',
    key: 14,
    companyDepartmentCode: '114_会社',
    districtCode: '14',
    districtName: 'SM第14地区',
  },
  {
    id: '15',
    key: 15,
    companyDepartmentCode: '115_会社',
    districtCode: '15',
    districtName: 'SM第15地区',
  },
  {
    id: '16',
    key: 16,
    companyDepartmentCode: '116_会社',
    districtCode: '16',
    districtName: 'SM第16地区',
  },
  {
    id: '17',
    key: 17,
    companyDepartmentCode: '117_会社',
    districtCode: '17',
    districtName: 'SM第17地区',
  },
  {
    id: '18',
    key: 18,
    companyDepartmentCode: '2501_会社',
    districtCode: '01',
    districtName: '1地区',
  },
  {
    id: '19',
    key: 19,
    companyDepartmentCode: '2502_会社',
    districtCode: '02',
    districtName: '2地区',
  },
];
